/** Placeholder das abas enquanto a leitura do ciclo não volta. */
export default function CartoesCarregando() {
  return (
    <div role="status" aria-label="Carregando" className="flex flex-col gap-3">
      <div className="h-24 animate-pulse rounded-2xl bg-surface-0 shadow-jj-01" />
      <div className="h-24 animate-pulse rounded-2xl bg-surface-0 shadow-jj-01" />
    </div>
  );
}
